import { IntlShape } from "react-intl";

type I18nKeys = {
  [field: string]: string | Record<string, unknown> | undefined;
  params?: Record<string, string | undefined>;
};

export const resolveI18n = (
  intl: IntlShape,
  i18nKeys: I18nKeys | undefined,
  field: string
): string | null => {
  const key = i18nKeys?.[field];
  if (typeof key !== "string") return null;
  return intl.formatMessage({ id: key }, i18nKeys?.params ?? {});
};
